import { Controller } from "stimulus"

// #1953: de centrale zoekbalk van platformbeheer. Haalt na een korte pauze de
// resultaten op (JSON van /platform/zoeken) en toont ze per categorie onder
// het zoekveld. Alles via textContent, nooit als HTML. Zonder JavaScript
// verstuurt Enter het formulier naar de gewone zoekpagina.
export default class extends Controller {
  static targets = ["veld", "resultaten"]
  static values = { url: String, leeg: String, alles: String }

  connect() {
    this.buitenKlik = (event) => { if (!this.element.contains(event.target)) this.sluit() }
    document.addEventListener("click", this.buitenKlik)
  }

  disconnect() {
    clearTimeout(this.wachten)
    document.removeEventListener("click", this.buitenKlik)
    if (this.verzoek) this.verzoek.abort()
  }

  typ() {
    clearTimeout(this.wachten)
    const term = this.veldTarget.value.trim()
    if (term.length < 2) return this.sluit()

    this.wachten = setTimeout(() => this.zoek(term), 250)
  }

  async zoek(term) {
    if (this.verzoek) this.verzoek.abort()
    this.verzoek = new AbortController()
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", term)
    try {
      const antwoord = await fetch(url, { headers: { Accept: "application/json" }, signal: this.verzoek.signal,
                                         credentials: "same-origin" })
      if (!antwoord.ok) return
      const data = await antwoord.json()
      if (this.veldTarget.value.trim() === term) this.toon(data, term)
    } catch (fout) {
      if (fout.name !== "AbortError") this.sluit()
    }
  }

  toon(data, term) {
    const doel = this.resultatenTarget
    doel.replaceChildren()
    const groepen = data.groepen || []
    if (groepen.length === 0) {
      const leeg = document.createElement("p")
      leeg.className = "pf-zoek-leeg"
      leeg.textContent = this.leegValue
      doel.append(leeg)
    }
    groepen.forEach((groep) => {
      const sectie = document.createElement("section")
      const kop = document.createElement("h3")
      kop.textContent = groep.label
      sectie.append(kop)
      const lijst = document.createElement("ul")
      groep.resultaten.forEach((regel) => {
        const item = document.createElement("li")
        const link = document.createElement("a")
        link.href = regel.url
        const titel = document.createElement("strong")
        titel.textContent = regel.titel
        link.append(titel)
        if (regel.sub) {
          const sub = document.createElement("span")
          sub.textContent = regel.sub
          link.append(sub)
        }
        item.append(link)
        lijst.append(item)
      })
      sectie.append(lijst)
      doel.append(sectie)
    })
    const alles = document.createElement("a")
    alles.className = "pf-zoek-alles"
    const pagina = new URL(this.element.action, window.location.origin)
    pagina.searchParams.set("q", term)
    alles.href = pagina.toString()
    alles.textContent = this.allesValue
    doel.append(alles)
    doel.hidden = false
    this.veldTarget.setAttribute("aria-expanded", "true")
  }

  sluit() {
    if (!this.hasResultatenTarget) return
    this.resultatenTarget.hidden = true
    this.veldTarget.setAttribute("aria-expanded", "false")
  }
}
